import { CgBreakpoints } from "../../components/common/cgBreakpoints";
import { Slider } from "../slider/slider";
import { debounce } from "underscore";


export class CardSlider {

    defaultOptions = {
        wrapperClass: 'card-slider__content',
        slideClass: 'card-news',
        bulletClass: 'card-slider__bullet',
        bulletActiveClass: 'card-slider__bullet--active',
        navigation: {
            prevEl: '.card-slider__button--prev',
            nextEl: '.card-slider__button--next'
        },
        hiddenClass: 'card-slider__button--hidden',
        slidesPerView: 'auto',
        pagination: {
            el: '.card-slider__pagination',
            clickable: true
        }
    };

    paginationTPL = '<div class="card-slider__pagination"/>';

    // staff
    aperture;
    navigation;

    constructor(el) {
        this.el = el;

        this.init();
    }

    init() {
        this.aperture = $(this.el);

        if (!this.aperture.length) {
            return;
        }

        this.setCardSlider();

        const slider = new Slider(this.aperture, this.defaultOptions);

        this.navigation = this.aperture.find([this.defaultOptions.navigation.prevEl, this.defaultOptions.navigation.nextEl].toString());

        this.update();

        $(window).resize(debounce(() => {
            this.update()
        }, 16));

        return slider;
    }

    setCardSlider() {
        this.aperture.append(this.paginationTPL);
    }

    update() {
        this.isMobile() ? this.navigation.addClass('card-slider__button--hidden') : this.navigation.removeClass('card-slider__button--hidden');
    }

    isMobile() {
        const cgBreakpoints = new CgBreakpoints();

        return cgBreakpoints.isMobile();
    }
}
